import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Upload } from 'component/Upload'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ChangeEvent, useRef } from 'react'
import { controller } from 'store/controller'
import { store } from 'store/store'
import { isMobileBrowser } from 'util/mobile'

export const SelfieBanner = observer(() => {
  const { banner, selfies, num } = store.profile.common
  const selfie = selfies[num]
  const cameraInputRef = useRef<HTMLInputElement>(null)
  const isMobile = isMobileBrowser()

  const onFile = useLatestCallback(async (file: File) => {
    selfies.forEach((it) => {
      if (it.origin === 'asset') it.clear()
    })
    selfie.setFile(file)
    controller.closeSelfieBanner()
  })

  const onTakePhoto = useLatestCallback(() => {
    if (isMobile) {
      cameraInputRef.current?.click()
    } else {
      store.profile.camera = true
      controller.closeSelfieBanner()
    }
  })

  const onCameraFile = useLatestCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0]
      if (file) {
        await onFile(file)
      }
      if (cameraInputRef.current) {
        cameraInputRef.current.value = ''
      }
    },
  )

  const onCancel = useLatestCallback(() => {
    controller.closeSelfieBanner()
  })

  return (
    <Banner hide={banner === 'hide'}
      title={String(i18n('UploadSelfies'))} onCancel={onCancel}>
      <Vertical gap={16}>
        <Typo size={13}>{i18n('TakePhotoOrUpload')}</Typo>
        <Button
          primary
          action={onTakePhoto}
          icon={<Icon name="photo_camera" size={20} />}
        >
          {isMobile ? i18n('TakeSelfiePhoto') : i18n('TakePhoto')}
        </Button>
        <Upload wide accept="image" onFile={onFile}>
          <Button wide icon={<Icon name="attach_file" size={20} />}>
            {i18n('UploadSelfieFromFiles')}
          </Button>
        </Upload>
        {isMobile && (
          <input
            ref={cameraInputRef}
            type="file"
            accept="image/*"
            capture="user"
            onChange={onCameraFile}
            style={{ display: 'none' }}
          />
        )}
      </Vertical>
    </Banner>
  )
})
